/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Next1Inputs */

const id_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const ms_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seterusnya`)
};

const da_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste`)
};

const de_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const en_us2_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const es_es2_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const es_mx2_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const fil_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod`)
};

const fr_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const it_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successivo`)
};

const hu_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő`)
};

const nl_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende`)
};

const no_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste`)
};

const pl_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna`)
};

const pt_br2_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const pt_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguinte`)
};

const ro_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Următor`)
};

const fi_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava`)
};

const sv_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa`)
};

const vi_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếp`)
};

const tr_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki`)
};

const cs_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další`)
};

const bg_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следващ`)
};

const ru_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const uk_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const ar_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const hi_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const th_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถัดไป`)
};

const ja_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

const zh_cn2_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一页`)
};

const zh_hant1_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一頁`)
};

const ko_offerdetail_changelog_next1 = /** @type {(inputs: Offerdetail_Changelog_Next1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Offerdetail_Changelog_Next1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_next1 = /** @type {((inputs?: Offerdetail_Changelog_Next1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Next1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_next1(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_next1(inputs)
	if (locale === "da") return da_offerdetail_changelog_next1(inputs)
	if (locale === "de") return de_offerdetail_changelog_next1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_next1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_next1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_next1(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_next1(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_next1(inputs)
	if (locale === "it") return it_offerdetail_changelog_next1(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_next1(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_next1(inputs)
	if (locale === "no") return no_offerdetail_changelog_next1(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_next1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_next1(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_next1(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_next1(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_next1(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_next1(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_next1(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_next1(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_next1(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_next1(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_next1(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_next1(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_next1(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_next1(inputs)
	if (locale === "th") return th_offerdetail_changelog_next1(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_next1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_next1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_next1(inputs)
	return ko_offerdetail_changelog_next1(inputs)
});
export { offerdetail_changelog_next1 as "offerDetail.changelog.next" }